import { render, staticRenderFns } from "./DocsTable.vue?vue&type=template&id=f467eed2&scoped=true"
import script from "./DocsTable.vue?vue&type=script&lang=js"
export * from "./DocsTable.vue?vue&type=script&lang=js"
import style0 from "./DocsTable.vue?vue&type=style&index=0&id=f467eed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f467eed2",
  null
  
)

export default component.exports